module.exports = __webpack_public_path__ + "img/icon_call.13af1e74.svg";